import "./index.scss";

import React, { useEffect, useState } from "react";
import gsap from "gsap";
import CustomButton from "../CustomButton";
import ServerError from "../ServerError";
import { useDropzone } from "react-dropzone";

const SignInSelect = ({ isOpen, setIsSignInSubmitted }) => {
  const [isServerError, setIsServerError] = useState(false);
  const [isFilesSelected, setFilesSelected] = useState(false);
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

  useEffect(() => {
    setFilesSelected(false);
  }, []);

  useEffect(() => {
    if (isFilesSelected || acceptedFiles.length) {
      setIsSignInSubmitted(true);
    } else {
      setIsSignInSubmitted(false);
    }
  }, [isFilesSelected, acceptedFiles]);

  useEffect(() => {
    setIsServerError(false);
  }, []);
  const handleFile = (e) => {
    console.log(e.target.files);
    try {
      setFilesSelected(true);
      setIsServerError(false);
    } catch (error) {
      setFilesSelected(false);
      setIsServerError(true);
    }
  };

  // drag&drop

  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  return (
    <div className={`select-files ${isOpen && 'select-files--active'}`}>
      <p className={`select-files__text`}>
        To migrate your inventory data and images into your MA Gallery account,
        upload them below.
      </p>
      <input
        type="file"
        name="images"
        id="imgid"
        className="select-files__input"
        onChange={handleFile}
        multiple
      />
      <p className={`select-files__text`}>Or</p>
      <div
        {...getRootProps({ className: "dropzone" })}
        className={`select-files-dropzone`}
      >
        <input {...getInputProps()} />
        <p className={`select-files-dropzone__text--box`}>
          drag and drop files here
        </p>
      </div>
      <div className={`select-files-dropzone__text--bottom`}>
        {files.length ? `${files.length} files` : "No files chosen"}
      </div>
      <ServerError isShown={isServerError} />
    </div>
  );
};

export default SignInSelect;
